exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Forms-832c95fc .demoBox-b1e1a171{max-width:420px}.Forms-832c95fc .imgPreview-e3ad491e{object-fit:cover;max-width:100%}.Forms-832c95fc .typedInputs-b69af2d0{display:flex;justify-content:space-between}\n", ""]);

// Exports
exports.locals = {
	"Forms": "Forms-832c95fc",
	"demoBox": "demoBox-b1e1a171",
	"imgPreview": "imgPreview-e3ad491e",
	"typedInputs": "typedInputs-b69af2d0"
};